export const EXO_SKELETON_RUNTIME_SCOPE = 'ExoSkeletonRuntime';
export const EXO_SKELETON_EVENT_NAMES = {
  TRACKING_HOST_MESSAGE_EVENT_NAME: 'exo-skeleton-tracking-host-message',
  NAVIGATION_HOST_MESSAGE_EVENT_NAME: 'exo-skeleton-navigation-host-message',
  MONITORING_HOST_REPORT_EVENT_NAME: 'exo-skeleton-monitoring-report-host-message',
  IMPORT_REMOTE_MESSAGE_EVENT_NAME: 'exo-skeleton-import-remote-message'
};
//# sourceMappingURL=consts.js.map